import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactInputMask from "react-input-mask";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
//components
import Input from "../../../components/input/Input";
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import MaskInput from "../../../components/input/MaskInput";
//services
import { postIbJuridico } from "../../../services/Settings/IbJuridico/postIbJuridico";
//utils
import { states } from "../../../utils/states";
import { handleCep } from "../../../utils/handleCep";

const RegisterIbJuridico = ({ setVisible, refetch, setSelected }) => {
  const form = useForm();
  const [doc, setDoc] = useState("");
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mask, setMask] = useState("99.999.999/9999-99");

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  };

  const onSubmit = async (data) => {
    let obj = {
      "name": data.name,
      "email": data.email,
      "contact": data.contact,
      "doc": data.doc,
      "address": {
        "cep": data.cep,
        "address": data.address,
        "city": data.city,
        "neighborhood": data.neighborhood,
        "state": data.state,
        "complement": data.complement,
      },
      "type": "register"
    }

    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await postIbJuridico(obj);
//      console.log(response);

      toast.update(notification, {
        render: "Escritório Cadastrado com sucesso!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });

    } catch (e) {
      if (e.response.data.error === "Dados ja registrado no Ib jurídico." || e.response.data.error === "Ib jurídico já configurado.") {
        toast.update(notification, {
          render: "Escritório já cadastrado no IB Jurídico, favor utilizar a chave de integração presente no em Meu Perfil no Ib Juridico!",
          autoClose: 5000,
          type: "warning",
          isLoading: false,
        });
        setSelected(2)
        setVisible(true)
      } else {
        toast.update(notification, {
          render: "Erro ao cadastrar escritório.",
          autoClose: 5000,
          type: "error",
          isLoading: false,
        });
      }

    }
    refetch();
    setLoading(false);





  }

  useEffect(() => {
    if (address && Object.keys(address).length !== 0) {
      form.setValue("address", address.address);
      form.setValue("city", address.city);
      form.setValue("neighborhood", address.neighborhood);
      form.setValue("state", address.state);
      form.clearErrors(["address", "city", "neighborhood", "state"])
    }
  }, [address]);


  return (
    <>
      <Panel >
        <form onSubmit={form.handleSubmit(onSubmit)} className="fs-13px">
          <div className="mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-landmark"></i> Dados da Empresa
            </label>
            <hr />
            <div className="row gx-3">
              <div className="col-md-3">
                <Input
                  isRequired
                  type="text"
                  control={form.control}
                  errors={form.formState.errors}
                  label="Nome *"
                  name="name"
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <ReactInputMask
                  mask={mask}
                  maskChar={null}
                  value={doc}
                  required
                  {...form.register("doc")}
                  onChange={(event) => watchMask(event.target.value)}
                  placeholder="CPF / CNPJ *"
                  className={`input-cpf ${doc ? "input-filled" : ""}`}
                />
              </div>
              <div className="col-md-3 mb-3">
                <Input
                  isRequired
                  name="email"
                  errors={form.formState.errors}
                  control={form.control}
                  type="email"
                  validationRules={{
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "E-mail inválido.",
                    },
                  }}
                  label="E-mail *"
                />
              </div>
              <div className="col-md-3">
                <MaskInput
                  name={`contact`}
                  mask="(99) 99999-999?9"
                  control={form.control}
                  isRequired
                  errors={form.formState.errors}
                  label={`Telefone *`}
                />
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-map-location"></i> Endereço da Empresa
            </label>
            <hr />
            <div className="row gx-3">
              <div className="col-md-3">
                <MaskInput
                  name="cep"
                  mask="99999-999"
                  onComplete={() => handleCep(form.getValues("cep"), setAddress)}
                  control={form.control}
                  errors={form.formState.errors}
                  isRequired
                  label={`CEP *`}
                />
              </div>
              <div className="col-md-3">
                <Input
                  name="num"
                  control={form.control}
                  errors={form.formState.errors}
                  label={`Número *`}
                  isRequired
                />
              </div>
              <div className="col-md-6">
                <Input
                  name="complement"
                  control={form.control}
                  errors={form.formState.errors}
                  label={`Complemento`}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="city"
                  control={form.control}
                  errors={form.formState.errors}
                  label={`Cidade *`}
                  isRequired
                />
              </div>

              <div className="col-md-3 mt-2">
                <Select
                  name="state"
                  label={`Estado *`}
                  errors={form.formState.errors}
                  control={form.control}
                  options={states}
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="address"
                  control={form.control}
                  errors={form.formState.errors}
                  label={`Rua *`}
                  isRequired
                />
              </div>
              <div className="col-md-3 mt-2">
                <Input
                  name="neighborhood"
                  control={form.control}
                  errors={form.formState.errors}
                  label={`Bairro *`}
                  isRequired
                />
              </div>
            </div>
          </div>

          <div className="text-end">
            <Button
              type="submit"
              label="Cadastrar"
              loading={loading}

            >

            </Button>
          </div>
        </form>
      </Panel>


    </>
  );
};

export default RegisterIbJuridico;
